import { snapItemsToString } from '~/features/shared/search/utils/snapItemsToString'
import { dedup } from '~/lib/dedup'
import { getTypeIdFromSort } from '~/lib/sort'
import { getUserTypeIdFromUserType } from '~/lib/userType'
import { NormalizedConditions } from '../types'

/* eslint-disable complexity */
export const buildQuery = (
  conditions: NormalizedConditions
): URLSearchParams => {
  const searchParams = new URLSearchParams(conditions.additionalQueries)

  if (conditions.age.from)
    searchParams.set('from_age', conditions.age.from.toString())
  if (conditions.age.to)
    searchParams.set('to_age', conditions.age.to.toString())

  if (conditions.height.from)
    searchParams.set('from_height', conditions.height.from.toString())
  if (conditions.height.to)
    searchParams.set('to_height', conditions.height.to.toString())

  if (conditions.month.from)
    searchParams.set('from_month', conditions.month.from.toString())
  if (conditions.month.to)
    searchParams.set('to_month', conditions.month.to.toString())

  if (conditions.brandIds.length > 0)
    searchParams.set('brand_ids', dedup(conditions.brandIds).join(','))
  if (conditions.shopIds.length > 0)
    searchParams.set('shop_ids', dedup(conditions.shopIds).join(','))
  if (conditions.tagIds.length > 0)
    searchParams.set('tag_ids', dedup(conditions.tagIds).join(','))

  if (conditions.hairstyleId)
    searchParams.set('hairstyle_id', conditions.hairstyleId.toString())
  if (conditions.bodyFrameTypeId)
    searchParams.set(
      'body_frame_type_id',
      conditions.bodyFrameTypeId.toString()
    )
  if (conditions.itemId)
    searchParams.set('item_id', conditions.itemId.toString())
  if (conditions.searchWord)
    searchParams.set('search_word', conditions.searchWord)

  // popularの場合はデフォルト値につき省略
  if (conditions.sort !== 'popular') {
    const typeId = getTypeIdFromSort(conditions.sort)?.toString()
    if (typeId) searchParams.set('type_id', typeId)
  }
  // allの場合はデフォルト値につき省略
  if (conditions.userType !== 'all') {
    const userType = getUserTypeIdFromUserType(conditions.userType)?.toString()
    if (userType) searchParams.set('user_type', userType)
  }

  if (conditions.snapItems.length > 1) {
    const snapItems = snapItemsToString(conditions.snapItems)
    if (snapItems) searchParams.set('snap_items', snapItems)
  } else {
    const [first] = conditions.snapItems
    if (first?.colorGroupId)
      searchParams.set('color_group_id', first.colorGroupId.toString())
  }

  return searchParams
}
